angular
	.module 'App.Directive'
	.directive 'formatDecimal', ['$filter', ($filter) ->
		require: '?ngModel'
		link: (scope, elem, attrs, ctrl) ->
			if !ctrl
				return

			ctrl.$parsers.push (val) ->
				if angular.isUndefined val
					val = ''

				clean = val.replace /[^.\d-]+/g, ''

				if val != clean
					ctrl.$setViewValue clean
					ctrl.$render()

				return clean

			elem.bind 'keypress', (event) ->
				if event.keycode == 32
					event.preventDefault()
	]
